var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 49,
    viewBox: "0 0 118 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1 0C28.8 5.38 17.21 31.74 17.09 32L16.13 34.24L10.05 48.19H6.34001L13.7 31.36L0 0H3.71001L15.61 27.13C16.44 25.02 19.77 17.4 27.38 0H31.09H31.1Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0667 15.8V18.17H50.6267C50.7977 20.164 51.4988 22.0759 52.6576 23.7077C53.8163 25.3394 55.3904 26.6315 57.2167 27.45C62.6567 30.01 69.5666 28.99 75.1366 24.31L77.3167 26.94C73.513 30.2602 68.6644 32.1395 63.6167 32.25C60.921 32.2549 58.2575 31.6641 55.8167 30.52C53.1433 29.2868 50.8919 27.2942 49.3431 24.7905C47.7943 22.2868 47.0165 19.3827 47.1066 16.44C47.1484 12.091 48.8952 7.93217 51.9715 4.85779C55.0477 1.78341 59.2077 0.0390993 63.5567 0C72.5567 0 80.0066 7.48 80.0066 15.8H80.0667ZM76.5466 14.8C76.0366 8.66 70.5466 3.41 63.5466 3.41C56.5466 3.41 51.0667 8.66 50.6167 14.8H76.5466Z",
    fill: "#231F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/YES.237e48d5f82f68d964218ea119b0a46a.svg";
export { ForwardRef as ReactComponent };